export const LOGO = "/logos/logo+wordmark.svg";
